import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { Button } from 'primereact/button'

const BUTTONS = [
  { mode: 'm', text: 'Perceptual Map' },
  { mode: 't', text: 'Topography view' },
  { mode: 'q', text: 'Quadrant view' }
]

// The switcher between a question's sub-modes. A block drawn in only one of them has nothing to
// offer here and hands its section no switcher at all.
const ModeSwitcher = ({ mode, onModelChange }) => (
  <div className="p-buttonset p-buttonset-fill">
    {BUTTONS.map(button => (
      <Button
        key={button.mode}
        className={classNames('p-button-rounded p-button-blue p-button-secondary', {
          'p-highlight': mode === button.mode
        })}
        label={button.text}
        onClick={() => onModelChange({ mode: button.mode })}
      />
    ))}
  </div>
)

ModeSwitcher.displayName = 'BpmModeSwitcher'

ModeSwitcher.propTypes = {
  mode: PropTypes.string.isRequired,
  onModelChange: PropTypes.func.isRequired
}

export default ModeSwitcher
